import React from "react";
import {Col, Row} from "react-bootstrap";

const AboutUs = () => {
    return (
        <div className={'base-box-pages-second'}>
            <div className={'base-box-page-about-us'}>
                <Row className="justify-content-center">
                    <Col xs={12} md={10} lg={8}>
                        <div>
                            <h3>درباره ما فعالیتهای ما</h3>
                            <span>فروت مروت چیست؟</span>
                        </div>
                        <div>
                            <p className={'text-justify'}>
                                فروت مروت یک فروشگاه اینترینی میوه و سبزیجات تازه است که خدمات منحصر به فردی را در شهر شیراز ارائه
                                می دهد. تضمین کیفیت، تضمین قیمت، ارسال سریع و مشتری مداری از اصول اولیه فروت مروت است.
                                ما مفتخر هستیم که به عنوان اولین فروشگاه تخصصی آنلاین میوه و سبزیجات در شیراز، خدمات خود را در بستر
                                اپلیکیشن های iOS و اندروید و همچنین نسخه وب مجموعه در دسترس همشهریان عزیز قرار می دهیم.
                                فروت مروت با توجه به ارتقاء روزافزون سطح کیفیت امکانات شهری در کلانشهر شیراز، افزایش ترافیک و
                                محدودیت زمانی، شیوه نوینی از خرید را بر اساس خدمات سریع و احترام به مشتری در حیطه میوه و سبزیجات
                                معرفی کرده است. هدف این مجموعه ایجاد دسترسی آسان و مطمئن به محصولات با کیفیت در جهت بهینه سازی هزینه
                                و زمان می باشد و همواره در این راه پیش خواهد رفت.
                                اپلیکیشن ها و وبسایت فروت مروت بر پایه سهولت عملکرد و سرعت بخشی به فرآیند خرید طراحی شده و با ارائه
                                اطلاعات صحیح از محصولات، همواره می کوشد اعتماد و رضایت مشتریان عزیز را جلب نماید. در این راستا فروت
                                مروت متعهد به ارائه قیمت مناسب، کیفیت بالا، خدمات ارسال رایگان در مناطق تحت پوشش و ایجاد امکان مرجوع
                                کردن آسان محصول بر طبق مقررات شرکت می باشد.
                            </p>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default AboutUs;
